import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ContributionAndWithdrawalBase } from "../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ContributionAndWithdrawalBase";
import { GiaHelper } from "./GiaHelper";
import { IsaHelper } from "./IsaHelper";
import { PaymentsHelper } from "./PaymentsHelper";
import { PensionHelper } from "./PensionHelper";
import { SubAccountTypeHelper } from "./SubAccountTypeHelper";

export class ChargesHelper {
    static getTotalForIACEstimation(data: any, type: SubAccountType) {
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            return PensionHelper.singlePaymentsTotal(data) + PensionHelper.transfersTotal(data);
        } else if (SubAccountTypeHelper.isIsa(type)) {
            return PaymentsHelper.singlePaymentsTotal(data) + IsaHelper.transfersTotal(data);
        } else if (SubAccountTypeHelper.isPP(type)) {
            return PaymentsHelper.singlePaymentsTotal(data) + GiaHelper.transfersTotal(data);
        } else {
            return PaymentsHelper.singlePaymentsTotal(data);
        }
    }

    static validateRIACAmount(data: any, type: SubAccountType, riac: number): boolean {
        let regularTotal = 0;
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            regularTotal = PensionHelper.regularPaymentsTotalForCharges(data);
        } else {
            regularTotal = PaymentsHelper.regularPaymentsTotalForCharges(data);
        }
        return riac > regularTotal;
    }

    static hasRegularPayments(data: any, type: SubAccountType): boolean {
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            return PensionHelper.hasRegularPayments(data);
        } else {
            return PaymentsHelper.hasRegularPayments(data);
        }
    }

    static hasSinglePayments(data: ContributionAndWithdrawalBase, type: SubAccountType): boolean {
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            return PensionHelper.hasSinglePayments(data);
        } else {
            return PaymentsHelper.hasSinglePayments(data);
        }
    }

    static hasTransfers(data: ContributionAndWithdrawalBase, type: SubAccountType): boolean {
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            return PensionHelper.hasPensionTransfers(data);
        } else if (type == SubAccountType.StocksIsa) {
            return IsaHelper.hasTransfers(data);
        } else if (type == SubAccountType.PersonalPortfolio || type == SubAccountType.InvestmentAccount) {
            return GiaHelper.hasTransfers(data);
        } else {
            return false;
        }
    }

    static displayIAC(data: ContributionAndWithdrawalBase, type: SubAccountType): boolean {
        const totalamount = this.getTotalForIACEstimation(data, type);
        return totalamount > 0;
    }

    static chargesProvided(data: ContributionAndWithdrawalBase): boolean {
        const iacAmount = data?.InitialAdviserCharge?.Money;
        const iacPercentage = data?.InitialAdviserCharge?.Percentage;
        const iacGiven = iacPercentage > 0 || (iacAmount && iacAmount.Amount && iacAmount.Amount > 0);

        const oacAmount = data?.OngoingAdviceCharge?.Money;
        const oacPercentage = data?.OngoingAdviceCharge?.Percentage;
        const oacGiven = oacPercentage > 0 || (oacAmount && oacAmount.Amount && oacAmount.Amount > 0);

        return iacGiven || oacGiven;
    }
}
